import PropTypes from 'prop-types'

import FileEntrySchema from './FileEntrySchema'

export default PropTypes.oneOfType([FileEntrySchema, PropTypes.string])
